import { render, staticRenderFns } from "./WidgetPanel.vue?vue&type=template&id=5b5a6274&scoped=true"
import script from "./WidgetPanel.vue?vue&type=script&lang=js"
export * from "./WidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./WidgetPanel.vue?vue&type=style&index=0&id=5b5a6274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a6274",
  null
  
)

export default component.exports